import { EntityService } from "@/model/service/entity-service"
import { Employee } from "@/model/entity/employee/employee"

class EmployeeService extends EntityService<Employee> {
  constructor() {
    super("employee", Employee)
  }

}

export interface IEmployeeService extends EntityService<Employee> {
}

export type EmployeeServiceType = typeof EmployeeService

const service = new EmployeeService()

export const employeeService = service
